import styled, { createGlobalStyle } from "styled-components";

export const ProfileCardHeader = styled.div`
  padding: 16px 0 14px;
  color: #d9dfe0;
  line-height: 22px;
  &.account-security {
    display: flex;
    justify-content: space-between;
  }
`;
export const ProfileDropdownStyle = createGlobalStyle`
.account-security-dropdown{
  .ant-dropdown-menu {
    background-color: rgba(0, 0, 0, 0.8);
    cursor: pointer;
  }
}
`;
export const ProfileCardDropdown = styled.div``;

export const ProfileCardDropdownButton = styled.div`
  cursor: pointer;
`;

export const ProfileLineWrapper = styled.div`
  margin: 0;
  > div {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    &:last-child {
      border: none;
    }
  }
`;

export const ProfileCard = styled.div`
  position: relative;
  background: #292b2f;
  padding: 0 24px 6px;
  border-radius: 4px;
  & + & {
    margin-top: 16px;
  }
  &.profile-card--main {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding-top: 24px;
    width: 480px;
    height: 100%;
    min-height: 650px;
    padding: 24px;
    justify-content: space-between;
  }
  &.charge-card {
    padding: 19px 0 0 0;
  }
  .profile-desktop-tabs {
    margin-top: 24px;
    > div {
      font-weight: 600;
    }
  }
`;

export const ChargeSmallCard = styled(ProfileCard)`
  flex: 1;
  background: #3f3f3f;
  height: 94px;
  padding: 22px 24px;
  &.capacity-card {
    flex: unset;
    // position: absolute;
    // width: calc(100% - 48px);
    width: 100%;
    margin-top: 12px;
    // bottom: 24px;
    height: 64px;
    background: #292b2f;
    border: 1px solid #404246;
    border-radius: 4px;
    padding: 8px 12px 0;
  }
  &.basic-unit {
    flex: 1;
    background: #292b2f;
    border: 1px solid #404246;
    border-radius: 4px;
    height: 64px;
    padding: 8px 12px 0;
  }
`;

export const CouponCount = styled.div`
  min-width: 22px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  font-size: 11px;
  background: #f4a125;
  border-radius: 42px;
  color: #ffffff;
`;

export const ChargeSmallCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  color: #bfc2c4;
  font-size: 12px;
  line-height: 17px;
`;

export const ProgressBar = styled.div`
  max-width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  margin-top: 16px;
`;

export const InnerProgress = styled.div<{ percent: number }>`
  height: 100%;
  width: ${({ percent }) => `${percent}%`};
  border-radius: 16px;
  transition: all 0.5s;
`;

export const IconWrapper = styled.div<{ size?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
`;

export const HelperLine = styled.div<{ height?: number }>`
  width: 1px;
  height: ${({ height }) => `${height || 14}px`};
  margin: 0 4px;
  background: #d9d9d9;
  opacity: 0.2;
`;

export const GapLine = styled.div<{ height?: string }>`
  height: ${(p) => p.height || "9px"};
  border-right: 1px solid #d0f6e9;
  border-color: inherit;
  &.capacity {
    border-color: #404146;
  }
`;
